import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useAdDetails } from './useAdDetails';
import { useCurrentCategory } from './useCurrentCategory/useCurrentCategory';
import { getCategoryPath } from '@/utils/helpers';

export function useCategoryPathSynchronizer() {
  const router = useRouter();
  const { currentCategory } = useCurrentCategory();
  const { adDetails } = useAdDetails();

  function synchronizePath() {
    const categoryPath = adDetails
      ? getCategoryPath(adDetails.path)
      : currentCategory?.path;
    const currentCategoryPath = getCategoryPath(router.asPath);

    if (
      categoryPath &&
      currentCategoryPath &&
      categoryPath !== currentCategoryPath
    ) {
      const newPath = router.asPath.replace(currentCategoryPath, categoryPath);
      router.replace(newPath);
    }
  }

  useEffect(() => {
    synchronizePath();
  }, [adDetails?.path, currentCategory?.path]);
}
